// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionButtonController from "./action_button_controller"
application.register("action-button", ActionButtonController)

import AddressesController from "./addresses_controller"
application.register("addresses", AddressesController)

import Forms__MultiSelectController from "./forms/multi_select_controller"
application.register("forms--multi-select", Forms__MultiSelectController)

import Forms__VariantPriceController from "./forms/variant_price_controller"
application.register("forms--variant-price", Forms__VariantPriceController)

import LayoutController from "./layout_controller"
application.register("layout", LayoutController)

import Orders__ShippingAddressesController from "./orders/shipping_addresses_controller"
application.register("orders--shipping-addresses", Orders__ShippingAddressesController)

import ProductCustomizationController from "./product_customization_controller"
application.register("product-customization", ProductCustomizationController)

import ProductDesignerController from "./product_designer_controller"
application.register("product-designer", ProductDesignerController)

import Products__SizeGuideController from "./products/size_guide_controller"
application.register("products--size-guide", Products__SizeGuideController)

import Products__TagsController from "./products/tags_controller"
application.register("products--tags", Products__TagsController)

import Stores__AdminsController from "./stores/admins_controller"
application.register("stores--admins", Stores__AdminsController)

import Stores__CustomFieldsController from "./stores/custom_fields_controller"
application.register("stores--custom-fields", Stores__CustomFieldsController)

import Stores__ProductsController from "./stores/products_controller"
application.register("stores--products", Stores__ProductsController)

import Erp__AssetPickerController from "./erp/asset_picker_controller"
application.register("erp--asset-picker", Erp__AssetPickerController)

import Erp__AutoSubmitController from "./erp/auto_submit_controller"
application.register("erp--auto-submit", Erp__AutoSubmitController)

import Erp__DialogController from "./erp/dialog_controller"
application.register("erp--dialog", Erp__DialogController)

import Erp__DropzoneController from "./erp/dropzone_controller"
application.register("erp--dropzone", Erp__DropzoneController)

import Erp__AutosaveController from "./erp/autosave_controller"
application.register("erp--autosave", Erp__AutosaveController)

import Erp__CustomerHistoryController from "./erp/customer_history_controller"
application.register("erp--customer-history", Erp__CustomerHistoryController)

import Erp__EstimateEditorController from "./erp/estimate_editor_controller"
application.register("erp--estimate-editor", Erp__EstimateEditorController)

import Erp__EstimateItemPricingController from "./erp/estimate_item_pricing_controller"
application.register("erp--estimate-item-pricing", Erp__EstimateItemPricingController)

import Erp__ExclusiveDisclosureController from "./erp/exclusive_disclosure_controller"
application.register("erp--exclusive-disclosure", Erp__ExclusiveDisclosureController)

import Erp__ActionMenuController from "./erp/action_menu_controller"
application.register("erp--action-menu", Erp__ActionMenuController)

import Erp__PositionSelectorController from "./erp/position_selector_controller"
application.register("erp--position-selector", Erp__PositionSelectorController)

import Erp__MarkingFormController from "./erp/marking_form_controller"
application.register("erp--marking-form", Erp__MarkingFormController)

import Erp__SelectChipsController from "./erp/select_chips_controller"
application.register("erp--select-chips", Erp__SelectChipsController)

import Erp__TabsController from "./erp/tabs_controller"
application.register("erp--tabs", Erp__TabsController)

import Erp__InlineEditController from "./erp/inline_edit_controller"
application.register("erp--inline-edit", Erp__InlineEditController)

import Erp__LightboxController from "./erp/lightbox_controller"
application.register("erp--lightbox", Erp__LightboxController)

import Erp__SearchController from "./erp/search_controller"
application.register("erp--search", Erp__SearchController)

import Erp__SearchableSelectController from "./erp/searchable_select_controller"
application.register("erp--searchable-select", Erp__SearchableSelectController)

import Erp__SidebarController from "./erp/sidebar_controller"
application.register("erp--sidebar", Erp__SidebarController)

import Erp__MobileSidebarController from "./erp/mobile_sidebar_controller"
application.register("erp--mobile-sidebar", Erp__MobileSidebarController)

import Erp__TextilePickerController from "./erp/textile_picker_controller"
application.register("erp--textile-picker", Erp__TextilePickerController)
